// extracted by mini-css-extract-plugin
export default {"textShadows":"OrderDetails_textShadows__Rtw6q"};